import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Project, Equipment } from 'models';
import { DateFormatPipe } from 'pipes/date-format.pipes';

@Injectable()
export class PrintService {
    iif(str: string, placeholder: string = '—') {
        return str ? str : placeholder;
    }

    formatDate(date: Date | null, placeholder: string = '—') {
        return date ? new DateFormatPipe().transform(date.toString()) : placeholder;
    }

    print(project: Project, equipments: Equipment[]) {
        const documentDefinition = {
            content: [
                {
                    columns: [
                        {
                            image: 'data:image/png;base64,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',
                            width: 45,
                            height: 50
                        },
                        {
                            text: 'LLFE Manager',
                            style: 'title'
                        }
                    ]
                },
                {
                    text: 'Project',
                    style: 'header'
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Type: ', style: 'label' },
                                this.iif(project.Type)
                            ]
                        },
                        {
                            text: [
                                { text: 'Status: ', style: 'label' },
                                this.iif(project.Status)
                            ]
                        },
                    ]
                },
                {
                    text: 'Names',
                    style: 'header'
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Name: ', style: 'label' },
                                this.iif(project.Name)
                            ]
                        },
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Number: ', style: 'label' },
                                this.iif(project.Number)
                            ]
                        },
                        {
                            text: [
                                { text: 'Placeholder number: ', style: 'label' },
                                this.iif(project.PlaceholderNumber)
                            ]
                        },
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Key name: ', style: 'label' },
                                this.iif(project.KeyName)
                            ]
                        },
                        {
                            text: [
                                { text: 'Key name free form: ', style: 'label' },
                                this.iif(project.KeyNameFreeForm)
                            ]
                        },
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Standard name: ', style: 'label' },
                                this.iif(project.StandardName)
                            ]
                        },
                        {
                            text: [
                                { text: 'C&D name: ', style: 'label' },
                                this.iif(project.CDName)
                            ]
                        },
                    ]
                },
                {
                    text: 'General information',
                    style: 'header'
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'Representative person: ', style: 'label' },
                                this.iif(project.Representative)
                            ]
                        },
                        {
                            text: [
                                { text: 'Project team: ', style: 'label' },
                                this.iif(project.Team)
                            ]
                        },
                    ]
                },
                {
                    columns: [
                        {
                            text: [
                                { text: 'AFE PreFund: ', style: 'label' },
                                this.iif(project.PreFundedAFE)
                            ]
                        },
                        {
                            text: [
                                { text: 'AFE PrimaryFund: ', style: 'label' },
                                this.iif(project.PrimaryFundAFE)
                            ]
                        },
                    ]
                },
                {
                    text: `Equipments (${equipments.length})`,
                    style: 'header'
                },
                this.getEquipmentsTable(equipments)
            ],

            styles: {
                title: {
                    fontSize: 22,
                    bold: true,
                    margin: [10, 13, 0, 0],
                    color: '#009DD9'
                },
                header: {
                    fontSize: 16,
                    bold: true,
                    margin: [0, 20, 0, 2]
                },
                label: {
                    bold: true,
                    lineHeight: 1.3
                },
                tableExample: {
                    fontSize: 10
                },
                tableHeader: {
                    bold: true
                }
            }
        };
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.createPdf(documentDefinition).print();
    }

    getEquipmentsTable(equipments: Equipment[]) {
        if (!equipments || !equipments.length) {
            return {
                text: 'No equipments added yet'
            };
        }

        return {
            style: 'tableExample',
            table: {
                headerRows: 1,
                width: ['*', 'auto', '*', '*', '*', '*'],
                body: [
                    [
                        { text: 'Serial #', style: 'tableHeader' },
                        { text: 'Equipment type', style: 'tableHeader' },
                        { text: 'Vendor', style: 'tableHeader' },
                        { text: 'Projected FAT Date', style: 'tableHeader' },
                        { text: 'PO #', style: 'tableHeader' },
                        { text: 'Status', style: 'tableHeader' },
                    ],
                    ...equipments.map(e => [
                        e.SerialNumber,
                        e.EquipmentType,
                        e.Vendor,
                        this.formatDate(e.ProjectedFATDate),
                        e.PurchaseOrderID,
                        e.DeliveryStatus
                    ])
                ],
            },
        };
    }
}
